import { render, staticRenderFns } from "./tab-references.vue?vue&type=template&id=0e015e11&"
import script from "./tab-references.vue?vue&type=script&lang=js&"
export * from "./tab-references.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports